import { Row } from 'react-bootstrap';
import styled from 'styled-components';

export const NewEntryRowWrapper = styled(Row)`
    @media (min-width: 768px) {
        & > .col-lg-6 > .form-group > .control-label {
            padding-top: 7px;
        }
    }
`;

export const RowWrapper = styled(Row)`
    & > div[class^="col-lg-"] {
        padding-top: 7px;
    }

    .form-control-static {
        border: 1px solid #ccc;
        border-radius: 4px;
        padding-left: 10px;
    }
`;

export const MatchListWrapper = styled.div`
    & > .match-row {
        padding: 5px;
        margin-bottom: 5px;
        border: 1px solid transparent;
    }

    & > .match-row:hover {
        border: 1px solid #eee;
        border-radius: 4px;
        cursor: pointer;
    }
`;